<template>
  <v-list-item class="filled-list-item">
    <v-list-item-content>
      <v-row align="center" justify="space-around">
        <v-col cols="12" sm="2">
          <span class="font-weight-bold">{{ directPurchase.raison }}</span>
        </v-col>
        <v-col cols="12" sm="2">
          <span>{{ directPurchase.montant_av_taxe }}</span>
          <span class="caption ml-1">$</span>
        </v-col>
        <v-col cols="6" sm="2">
          <span>{{ directPurchase.tps }}</span>
          <span class="caption ml-1">$tps</span>
        </v-col>
        <v-col cols="6" sm="2">
          <span>{{ directPurchase.tvq }}</span>
          <span class="caption ml-1">$tvq</span>
        </v-col>
        <v-col cols="12" sm="2">
          <span>{{ directPurchase.montant }}</span>
          <span class="caption ml-1">$</span>
        </v-col>
      </v-row>
    </v-list-item-content>
    <v-list-item-action>
      <v-btn icon ripple @click="() => $emit('remove', index)">
        <v-icon color="grey lighten-1">delete</v-icon>
      </v-btn>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: "TillDirectPurchaseTile",
  props: {
    directPurchase: {
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  }
};
</script>

<style scoped lang="scss">
.filled-list-item {
  background-color: rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  margin-top: 0.5rem;
}
</style>
